import { useTranslation } from 'react-i18next'
import { Droplets } from 'lucide-react'
import { formatDrops } from '@/lib/format-drops'

interface DropsPriceProps {
  count: number
  /** Tailwind size class for the icon. Default: 'w-3.5 h-3.5' */
  iconSize?: string
  /** Extra className on the wrapper span */
  className?: string
  /** Abbreviate large numbers (≥10M → "10M"). Off by default — enable only on balance displays. */
  abbreviate?: boolean
}

export function DropsPrice({ count, iconSize = 'w-3.5 h-3.5', className = '', abbreviate = false }: DropsPriceProps) {
  const { t } = useTranslation('offers')
  const display = abbreviate ? formatDrops(count) : count.toLocaleString()
  return (
    <span className={`inline-flex items-center gap-1 ${className}`}>
      <Droplets className={`${iconSize} text-ocean-500 dark:text-ocean-300 flex-shrink-0`} aria-label={t('price.dropsAriaLabel')} />
      <span className="tabular-nums font-display">{display}</span>
    </span>
  )
}
